<template>
    <div >
        <div v-if="currentComponent != 'LoginView' && currentComponent != 'Loading'">
            <div class="flex">
                <Sidebar v-if="windowWidth > 1300" class="w-[286px]" />
                <MinSidebar v-else class="w-[100px]"/>
                <div class="w-full">
                    <component :is="currentComponent"></component>
                </div>
            </div>
        </div>
        <div v-else>
            <component :is="currentComponent"></component>
        </div>
    </div>
</template>

<script>
    import MainView from '../views/MainView.vue'
    import LoginView from '../views/LoginView.vue'
    import Sidebar from '../components/Sidebar.vue'
    import MinSidebar from '../components/MinSidebar.vue'

    import StudentsView from '../views/StudentsView.vue'
    import GroupsView from '../views/GroupsView.vue'
    import FinanceView from '../views/FinanceView.vue'
    import TrainingsView from '../views/TrainingsView.vue'
    import SettingsView from '../views/SettingsView.vue'

    import { ref } from 'vue'
    import { useRouter, useRoute } from 'vue-router'
    import { onMounted, onUpdated } from 'vue'

    export default {
        name: 'MainLayout',
        
        setup() {
            const currentComponent = ref('LoginView')
            const router = useRouter()
            const route = useRoute()
            const windowWidth = ref(window.innerWidth)


            onMounted(async () => {
                if (localStorage.access_token && localStorage.refresh_token) {                    
                    currentComponent.value = route.meta.component
                } else {
                    currentComponent.value = 'LoginView'
                }

                window.addEventListener('resize', () => {
                    windowWidth.value = window.innerWidth
                })
            })

            onUpdated(() => {
                if (localStorage.access_token && localStorage.refresh_token) {
                    currentComponent.value = route.meta.component
                }
            })

            return {
                currentComponent,
                windowWidth
            }
        },

        components: {
            MainView,
            LoginView,
            MinSidebar,
            Sidebar,
            StudentsView,
            GroupsView,
            FinanceView,
            TrainingsView,
            SettingsView
        }
    }
</script>